const CommonUtils = {
  isTouchDevice: 'ontouchstart' in window,
};

export default CommonUtils;
